export enum ContentType {
    Live = 'Live',
    LiveDvr = 'LiveDvr',
    Vod = 'Vod'
}
